{
  "nl": {
    "milestone": {
      "actions": {
        "activate": "Activeer",
        "active": "Actief!",
        "create": "Mijlpaal aanmaken",
        "deactivate": "Deactiveer",
        "delete": "Verwijder",
        "delete_milestones": "Mijlpaal verwijderen | {count} mijlpalen verwijderen",
        "new": "Mijlpaal"
      },
      "attach": {
        "add": "Toevoegen",
        "add_button": "Toevoegen",
        "add_kind": "{kind} toevoegen",
        "assigned_tag": "Toegewezen",
        "back": "Terug",
        "counts": "{available} beschikbaar · {assigned} reeds toegewezen",
        "description_decision": "Keuzes die de klant moet maken",
        "description_survey": "Vragenlijsten om input te verzamelen",
        "empty": "Geen elementen beschikbaar",
        "empty_state_description": "Op basis van je abonnement kun je {kinds} toevoegen aan deze mijlpaal.",
        "empty_state_title": "Nog geen elementen",
        "intro": "Kies welke soort element je wilt koppelen aan deze mijlpaal.",
        "next": "Volgende",
        "search": "Zoeken",
        "select_intro": "Selecteer de {kind} die je wilt toevoegen.",
        "subtitle": "Aan mijlpaal: {name}",
        "success": "Elementen toegevoegd",
        "title": "Elementen toevoegen"
      },
      "labels": {
        "add_element": "Element toevoegen",
        "add_kind": "{kind} toevoegen",
        "assign_units": "Units toewijzen",
        "assigned_count": "0 toegewezen | 1 toegewezen | {count} toegewezen",
        "assigned_elements": "Toegewezen elementen",
        "assigned_empty_description": "Koppel {kinds} aan deze mijlpaal",
        "assigned_empty_title": "Nog geen elementen",
        "bulk_assign_title": "Selecteer units waaraan u mijlpaal '{milestone_name}' wilt toewijzen",
        "edit_milestone": "Mijlpaal bewerken",
        "empty_state_subtitle": "Mijlpalen maken het bouwproces transparanter voor woningkopers",
        "empty_state_title": "Maak een nieuwe mijlpaal aan",
        "future_milestones": "Toekomstige mijlpalen",
        "kind_decision": "Beslissing | Beslissingen",
        "kind_survey": "Enquête | Enquêtes",
        "kind_todo": "Taak | Taken",
        "milestone": "Mijlpaal",
        "milestone_name": "Naam van mijlpaal",
        "milestone_unit_count": "0 units | 1 unit | {count} units",
        "milestones": "Mijlpalen",
        "new_milestone": "Nieuwe mijlpaal",
        "no_milestone": "Nog geen mijlpaal toegewezen",
        "no_results": "Geen mijlpalen gevonden",
        "past_milestones": "Eerdere mijlpalen",
        "please_select": "Selecteer een nieuwe mijlpaal",
        "position": "Positie",
        "search_empty_state": "Nog geen mijlpalen aangemaakt. Klik hier om te starten",
        "units": "Units",
        "units_without_milestone": "1 unit zonder mijlpaal | {count} units zonder mijlpaal",
        "warning_delete": "Als u een mijlpaal verwijdert die aan een unit is toegewezen zal deze klant geen mijlpalen meer zien. Zorg ervoor dat u een nieuwe mijlpaal toewijst aan deze units!"
      },
      "toasts": {
        "bulk_assigned": "De mijlpaal is succesvol toegewezen aan de geselecteerde units",
        "create_success": "Mijlpaal succesvol aangemaakt",
        "deactivate_success": "Mijlpaal is succesvol gedeactiveerd",
        "sup_assigned": "De mijlpaal is succesvol geactiveerd",
        "update_success": "Mijlpalen zijn succesvol bijgewerkt"
      },
      "validation": {
        "needName": "Naam is verplicht",
        "needNamePrimary": "De naam in de primaire taal ({language}) is verplicht"
      }
    }
  }
}
